import script from "./EditEventView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditEventView.vue?vue&type=script&setup=true&lang=ts"

import "./EditEventView.vue?vue&type=style&index=0&id=b4173e8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4173e8c"]])

export default __exports__